import { PrecisionNumberInput } from './PrecisionNumberInput';

interface DegreeInputProps {
  value: number; // value in radians
  onChange: (value: number) => void; // callback expects radians
  className?: string;
}

export function DegreeInput({
  value,
  onChange,
  className = 'h-7 rounded-md border border-white/12 bg-[#0d1928e6] px-2 text-[0.72rem] text-white outline-none transition-colors focus:border-white/30',
}: DegreeInputProps) {
  const radiansToDegrees = (rad: number) => {
    const deg = rad * (180 / Math.PI);
    return Math.round(deg / 1e-6) * 1e-6;
  };
  const degreesToRadians = (deg: number) => deg * (Math.PI / 180);

  return (
    <PrecisionNumberInput
      value={radiansToDegrees(value)}
      onChange={degrees => onChange(degreesToRadians(degrees))}
      className={className}
    />
  );
}
